export const PAGE_VISIT_QUERY_KEY = 'page_visit';
export const STATS_QUERY_KEY = 'stats';
